import {
  all,
  call, put, select, takeLatest
} from 'redux-saga/effects';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch.js';

import { addRouteToMap, removeLayerFromMap } from 'react/utils/routeMonitorMultiRoutes';
import { getResourceTo } from 'react/utils/utils';
import { actionCreators, actions } from '../actions/monitor';
import { actionCreators as toastActions } from '../actions/toastAlerts';

export const url = '/RouteView/Monitor';

export function* prepareSaga(action) {
  const newAction = { ...action };
  const { payload } = newAction;
  const state = yield select();

  if (!payload) {
    const { filter } = state;
    newAction.payload = {
      ...filter,
      firstResult: 0
    };
  }

  const data = yield call(defaultFetch, url, newAction.payload, 'POST');

  yield put(actionCreators.requestSuccess(data));
}

export function* paginateSaga(action) {
  const data = yield call(defaultFetch, url, action.payload, 'POST');

  yield put(actionCreators.paginateSuccess(data));
}

function* updateClassForToolbarEl() {
  const routesOnMap = yield getRoutesOnMap();
  const button = document.querySelector('#Maps .mapToolBar .btnToggleMultiroute');

  if (button && routesOnMap.length) {
    button.classList.add('selected');
  } else {
    button.classList.remove('selected');
  }
}

function* getRoutesOnMap() {
  const { routesOnMap } = yield select((state) => state.routeMonitor);

  return routesOnMap;
}

function* getNextAvailableRouteColor() {
  const routesOnMap = yield getRoutesOnMap();

  const colors = ['purple', 'green', 'red', 'blue', 'orange'];
  const routeColors = routesOnMap.map((item) => item.color);

  const availableColor = colors.find((color) => !routeColors.includes(color));

  return availableColor;
}

function* routeIsOnMap(id) {
  const routesOnMap = yield getRoutesOnMap();

  return routesOnMap.some((item) => item.id === id);
}

function* addRouteToMapSaga(action) {
  const { id } = action.payload;
  const routeIsAlreadyOnTheMap = yield routeIsOnMap(id);

  if (routeIsAlreadyOnTheMap) {
    return;
  }

  const routesOnMap = yield getRoutesOnMap();

  const MAX_ROUTES_ON_MAP = 5;

  if (routesOnMap.length === MAX_ROUTES_ON_MAP) {
    yield put(toastActions.addToast({
      id: 'routesOnMapLimit',
      type: 'danger',
      data: {
        title: getResourceTo('routeMonitor.routesOnMapLimit.title'),
        description: getResourceTo('routeMonitor.routesOnMapLimit.description', MAX_ROUTES_ON_MAP)
      }
    }));

    return;
  }

  yield put(actionCreators.toggleMapState());

  const { map } = Monet.Session.mainMap;
  const color = yield getNextAvailableRouteColor();

  yield addRouteToMap({
    map,
    routeId: id,
    color
  });

  yield put(actionCreators.updateRoutesOnMap([
    ...routesOnMap,
    {
      id,
      color
    }
  ]));

  yield updateClassForToolbarEl();
  yield put(actionCreators.toggleMapState());
}

function* removeRouteFromMapSaga(action) {
  const { id } = action.payload;

  const routeIsAlreadyOnTheMap = yield routeIsOnMap(id);

  if (!routeIsAlreadyOnTheMap) {
    return;
  }

  yield put(actionCreators.toggleMapState());

  const { map } = Monet.Session.mainMap;
  const { focusedRouteOnMap } = yield select((state) => state.routeMonitor);

  if (focusedRouteOnMap === id) {
    yield put(actionCreators.removeFocusedRouteOnMap());
  }

  yield removeLayerFromMap(map, `ROUTE_PATH_${id}`);

  const routesOnMap = yield getRoutesOnMap();

  yield put(actionCreators.updateRoutesOnMap(routesOnMap.filter((item) => item.id !== id)));

  yield updateClassForToolbarEl();
  yield put(actionCreators.toggleMapState());
}

function* removeAllRouteFromMapSaga() {
  const { map } = Monet.Session.mainMap;

  yield put(actionCreators.toggleMapState());
  yield put(actionCreators.removeFocusedRouteOnMap());

  const routesOnMap = yield getRoutesOnMap();
  const layersToRemove = routesOnMap.map((item) => removeLayerFromMap(map, `ROUTE_PATH_${item.id}`));

  yield all(layersToRemove);
  yield put(actionCreators.updateRoutesOnMap([]));

  yield put(actionCreators.toggleMapState());
}

export function* paginateRouteMonitor() {
  yield takeLatest(actions.paginate, paginateSaga);
}

export function* routeMonitor() {
  yield takeLatest(actions.request, prepareSaga);
}

export function* watchAddRouteToMap() {
  yield takeLatest(actions.addRouteToMap, addRouteToMapSaga);
}

export function* watchRemoveRouteFromMap() {
  yield takeLatest(actions.removeRouteFromMap, removeRouteFromMapSaga);
}

export function* watchRemoveAllRouteFromMap() {
  yield takeLatest(actions.removeAllRoutesFromMap, removeAllRouteFromMapSaga);
}

export default function* () {
  yield all([
    routeMonitor(),
    watchAddRouteToMap(),
    watchRemoveRouteFromMap(),
    watchRemoveAllRouteFromMap()
  ]);
}
